import { Grid } from '../../../../../Common/Grid'
import { TitleHeader } from '../../../../Common/TitleHeader'
import { URLS } from '../../../../constants'
import { generatePath, useNavigate } from "react-router-dom"
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from '../../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import React from 'react'
import { useNotification } from '../../../../../../../hooks'
import { CircularProgress, Paper, Typography } from "@mui/material"

const InProgressReception = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()

  const {
    data: truckList,
    isLoading,
    isError
  } = useQuery(
    'inProgressDsTrucks',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/ds-order/list/in-progress', null)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching trucks. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  if (isError) {
    return (
      <Typography
        variant="light"
        component="p"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
      >
        A aparut o eroare la obtinerea datelor.
      </Typography>
    )
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="Procesarea Recepției" />,
        ...(truckList?.length > 0
          ? truckList?.map((order: any) => (
            <Paper
              elevation={3}
              style={{ margin: '10px', padding: '20px', cursor: 'pointer' }}
              onClick={() => {
                const basePath =
                  order.dsDeliveryStatus === 'PRODUCTS_PROCESSED'
                    ? URLS.AUTH_SUPPLIERS_PACKAGE_INPUT
                    : order.dsDeliveryStatus === 'SUPPORTS_PROCESSED'
                      ? URLS.AUTH_SUPPLIERS_RECEIPT_REPORT
                      : URLS.AUTH_SUPPLIERS_GOODS_VALIDATION

                navigate(generatePath(basePath, { id: order.id }) + `?supplierCode=${order.supplierCode}`)
              }}
            >
              <Typography variant="medium" component="h5">
                {order.supplierCode}
              </Typography>
              <Typography variant="medium" component="p">
                {order.supplierName}
              </Typography>
              <Typography variant="medium" component="p">
                {order.rayonName}
              </Typography>
              <Typography variant="medium" component="p">
                {order.shopCode}
              </Typography>
              <Typography variant="medium" component="h5">
                Nr. comanda: {order.orderNumber}
              </Typography>
            </Paper>
          ))
          : [
            <div key="no-trucks" style={{ textAlign: 'center' }}>
              Nu există comenzi în lucru.
            </div>
          ])
      ]}
      itemsPerRow={1}
    />
  )
}

export default InProgressReception
